'use strict';

function controller (
    vdpConsumerReviewService,
    $rootScope,
    $sce
) {
    const ctrl = this;
    const REVIEW_CHAR_LIMIT = 465;
    ctrl.reviews = [];
    ctrl.tagSelect = tagSelect;
    ctrl.selectedTag = {
        code: 'all',
        displayNm: 'All'
    };

    ctrl.tagMode = false;

    $rootScope.$on('tagChange', (event, newTag) => {
        if (newTag) {
            tagSelect(newTag);
        }
    });

    function tagSelect(tag){
        return vdpConsumerReviewService
        .getReviewsByTag(ctrl.productId, tag.code, ctrl.apiHost, ctrl.apiKey)
        .then((reviews) => {
            ctrl.selectedTag = tag;
            ctrl.reviews = reviews.map((review, index) => formatReview(review, index));
            ctrl.tagMode = true;
        });
    }

    function formatReview(review, index){
        let submitDate = new Date(review.submittedDateUtc);
        review.submittedDate = submitDate.toDateString();
        review.displayText = review.reviewTxt;
        if (review.reviewTxt.length > REVIEW_CHAR_LIMIT) {
            review.displayText = review.reviewTxt.substring(0, REVIEW_CHAR_LIMIT);
            review.hiddenText = review.reviewTxt.substring(REVIEW_CHAR_LIMIT);
        }
        if (ctrl.selectedTag.code !== 'all') {
            let regex = new RegExp(ctrl.selectedTag.displayNm, "ig");
            review.displayText = $sce.trustAsHtml(review.displayText.replace(regex, '<span class="highlight">' + ctrl.selectedTag.displayNm + '</span>'));
            if (review.hiddenText) {
                review.hiddenText = $sce.trustAsHtml(review.hiddenText.replace(regex, '<span class="highlight">' + ctrl.selectedTag.displayNm + '</span>'));
            }
        } else {
            review.displayText = $sce.trustAsHtml(review.displayText);
            if (review.hiddenText) {
                review.hiddenText = $sce.trustAsHtml(review.hiddenText);
            }
        }
        review.id = "consumer-review-" + (index + 1);

        return review;
    }
}

controller.$inject = [
    'vdpConsumerReviewService',
    '$rootScope',
    '$sce'
];

export default controller;